import { ReactNode } from "react";
import { toast as sonnerToast } from "sonner";
import { ErrorIcon, InfoIcon, SuccessIcon } from "../icons";
import { Button, ButtonProps } from "./button";

export interface ToastProps {
  id?: string | number;
  type?: "default" | "success" | "error" | "info";
  title: string;
  description?: string;
  duration?: number;
  button?: Omit<ButtonProps, "children"> & {
    label: ReactNode;
  };
}

export function Toast(props: ToastProps) {
  const { title, type = "default", description, button, id } = props;
  const { label, onClick, ...buttonProps } = button ?? {};

  return (
    <div className="flexrounded-lg bg-white shadow-lg ring-1 ring-black/5 w-full md:max-w-[364px] items-center p-4">
      <div className="flex items-center max-w-96">
        {type === "success" && (
          <div className="mr-3">
            <SuccessIcon className="size-6" />
          </div>
        )}
        {type === "error" && (
          <div className="mr-3">
            <ErrorIcon className="size-6" />
          </div>
        )}
        {type === "info" && (
          <div className="mr-3">
            <InfoIcon className="size-6" />
          </div>
        )}
        <div className="w-full">
          <p className="text-sm font-medium text-neutral-900">{title}</p>
          {description && (
            <p className="mt-1 text-sm text-muted-foreground">{description}</p>
          )}
        </div>
        {button && (
          <div className="ml-8 shrink-0">
            <Button
              {...buttonProps}
              onClick={(e) => {
                if (onClick) {
                  onClick(e);
                }
                sonnerToast.dismiss(id);
              }}
            >
              {label}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export function toast(props: ToastProps): string | number;
export function toast(
  title: string,
  props?: Partial<ToastProps>,
): string | number;
export function toast(
  arg1: string | ToastProps,
  arg2?: Partial<ToastProps>,
): string | number {
  let props: ToastProps;

  if (typeof arg1 === "string") {
    props = { ...arg2, title: arg1 };
  } else {
    props = arg1;
  }

  return sonnerToast.custom((id) => <Toast id={id} {...props} />, {
    id: props.id,
    duration: props.duration,
  });
}

export function dismissToast(id: string | number) {
  sonnerToast.dismiss(id);
}
